import React, { memo } from "react";

interface IProps {
  className?: string;
}

const ArrowBreadcrumb: React.FC<IProps> = memo(({ className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      className={`${className ? className : ""}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C9.05058 0 10.0909 0.206926 11.0615 0.608964C12.0321 1.011 12.914 1.60028 13.6569 2.34315C14.3997 3.08601 14.989 3.96793 15.391 4.93853C15.7931 5.90914 16 6.94943 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C6.94943 16 5.90914 15.7931 4.93853 15.391C3.96793 14.989 3.08601 14.3997 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8ZM12.8 7.2H6.4L9.2 4.4L8.064 3.264L3.328 8L8.064 12.736L9.2 11.6L6.4 8.8H12.8V7.2Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { ArrowBreadcrumb };
